import "@babel/polyfill";

// Polyfills
import './forEach';
import './includes';
import './customEvent';
import './scrollingElement';
import './prepend';
import './closest';

// Function to make IE9+ support forEach:
(function () {
    if (typeof NodeList.prototype.forEach === "function")
        return false;
    else
        NodeList.prototype.forEach = Array.prototype.forEach;
})();

// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
